import { Injectable, OnInit } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/Rx';

//import { Interface } from 'readline';
import { NumberSymbol } from '@angular/common';
import { root } from 'rxjs/internal-compatibility';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { ConfigService } from '../config.service';
import { DOCUMENT, Location, LocationStrategy, PlatformLocation } from '@angular/common';



import { forkJoin, interval, of } from 'rxjs';
import { Entrada } from '../@core/data/entrada';
import { Palet } from '../@core/data/palet';
import { map, switchMap } from 'rxjs/operators';


export interface Listado{
  id: number;
  name: string;
  
}
export interface LineaFactura{
  idconcepto:number;  
  unidades:number;  
  valor_unitario:number;
  subtotal:number;
}

export interface Factura{
    idexpediente:number;  
    nombreyapellidos:string;  
    direccion:string;
    nif:string;
    localidad:string;
    provincia:string; 
    cp:number;
    lineas:LineaFactura[];
    total:number;
    idimpuestos:number;     
}

export interface ExpedienteFacturable{
  etiquetas: string;
  alta: string;
  federacion: string;
  sector: string;
  fecha_cierre: string;
  cliente_mn: string;
  dni: string;
  nombre_completo: string;
  abogado_ugt: string;
  factura: number;
}

export interface Respuesta4{
  code: number;
  mensaje: string;
  lineas: any[];
  totales: any[];
}
export interface Respuesta3{
  code: number;
  mensaje: string;
  data: any[];
}

export interface Respuesta2{
  code: number;
  mensaje: string;
  data;
}

export interface Respuesta{
  code: number;
  data;
}

export interface Partida{
  idubicacion:number;
  idpartida:number;
  partida:string;
  lote:string;
  variedad:string;
  etiqueta:number;
  lineas: Lineas[]
}

export interface infolinea{
  fechaini:string;
  fechafin:string;
  partida:string;
  lote:string;
  calibre:string;
  variedad:string;
  categoria:string;
  etiquetas:number;
  cajas:number;
  tipo:string;
  peso:number;
}

export interface Lineas{
  id_lineas:number;
  id:number;
  categoria:number;
  calibre:number;
  peso:number;
  etiquetas:number;
  cajas:number;
  impresora:number;
}
@Injectable({
  providedIn: 'root'
})
export class HttpserviceService implements OnInit {

  public idempresa;
  public idubicacion;
  public idcamara;
  public urlwebsockets;
  
  constructor(private http: HttpClient,private router:Router,private auth:AuthService, private config:ConfigService) { 
    const origin = window.location.origin || '';
    const isAngularDevServer = origin.includes(':4200');

    if (!config.debug && !isAngularDevServer) {
      this.urlbase = origin + "/";
    } else {
      this.urlbase = config.urlbase;
    }

    this.urlwebsockets= "ws://"+this.getDomainFromUrl(this.urlbase)+":9502/";
  }
  

    getDomainFromUrl(url: string): string {
      try {
        const urlObject = new URL(url);
        return urlObject.hostname; // Obtiene el dominio (hostname) de la URL
      } catch (error) {
        console.error('Error al analizar la URL:', error);
        return ''; // Retorna un string vacío o maneja el error como prefieras
      }
    }

  ngOnInit(): void {
    this.getColaEtiquetas().subscribe(data => {
      
      this.urlwebsockets = data.data;
    }, error => console.error(error));
  }


  //public urlbase="http://127.0.0.1/";
  //public urlbase="http://192.168.59.173/trazabilidad/";
  urlbase="";
  public impresoras;
  

  public pesos; 
  

  public calibres ;

public etiquetas ;

  public categorias;

  public partida: Partida;

  public idtienda: string;
    /*
    {id: 1,name: "I"},
    {id:2,name:"II"},
    {id:3,name:"III"},
    {id:4,name:"IV"},
  ]*/

// Aplicación WARE
getColaEtiquetas(): Observable<any>{
  let dato:any=  this.http.get(this.urlbase+"ware/getcolaimpresion.php");  
  this.urlwebsockets=dato.data;
  return dato;
}
//ENTRADAS

// Auto-ubicación masiva de palets de una entrada en una cámara
autoUbicarEntrada(identrada: number, idcamara: number): Observable<any> {
  const payload = { identrada, idcamara };
  let dato: any = this.http.post(this.urlbase + "ware/entrada/autoUbicarEntrada.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getEntradas(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/entrada/getentradas.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
addEntrada(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/entrada/createentrada.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

modifyEntrada(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/entrada/modifyentrada.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

syncEntradasAliquo(): Observable<any>{
  let dato:any=this.http.get(this.urlbase+"ware/entrada/sync_entradas_aliquo.php");
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
//MAestros

getProductores(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getproductores.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getProductos(id:number, incluirTodos: boolean = false): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    const todos = incluirTodos ? '&todos=1' : '';
    let dato:any=this.http.get(this.urlbase+"ware/maestros/getproductos.php?id="+id+todos);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getProductosEntradas(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getproductos_entradas.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getTiposCaja(id:number): Observable<any> {
    let dato:any=this.http.get(this.urlbase+"ware/tipo_caja/gettiposcaja.php?idempresa="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateTipoCaja(tipoCaja: any): Observable<any> {
  let dato:any = this.http.post(this.urlbase+"ware/tipo_caja/modifytipocaja.php", tipoCaja);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getStockProductosPalet(id:number,fecha:string, filtrosEntrada?: any): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));
    let url = this.urlbase+"ware/stock/getproductospalet.php?id="+id+"&fecha="+encodeURIComponent(fecha);
    if (filtrosEntrada) {
      if (filtrosEntrada.madurez) {
        url += "&madurez=" + encodeURIComponent(filtrosEntrada.madurez);
      }
      if (filtrosEntrada.aspecto_exterior) {
        url += "&aspecto_exterior=" + encodeURIComponent(filtrosEntrada.aspecto_exterior);
      }
      if (filtrosEntrada.firmeza) {
        url += "&firmeza=" + encodeURIComponent(filtrosEntrada.firmeza);
      }
    }
    let dato:any=this.http.get(url);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getStockProductosCaja(id:number,fecha:string, filtrosEntrada?: any): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));
    let url = this.urlbase+"ware/stock/getproductoscaja.php?id="+id+"&fecha="+encodeURIComponent(fecha);
    if (filtrosEntrada) {
      if (filtrosEntrada.madurez) {
        url += "&madurez=" + encodeURIComponent(filtrosEntrada.madurez);
      }
      if (filtrosEntrada.aspecto_exterior) {
        url += "&aspecto_exterior=" + encodeURIComponent(filtrosEntrada.aspecto_exterior);
      }
      if (filtrosEntrada.firmeza) {
        url += "&firmeza=" + encodeURIComponent(filtrosEntrada.firmeza);
      }
    }
    let dato:any=this.http.get(url);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}



// PALETS-ENTRADAS

deleteEntrada(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/entrada/deleteentrada.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getPaletsEntrada(id:number):  Observable<any> {
  if (!this.urlbase) {
    throw new Error('urlbase no está inicializado');
  }
  if (!this.http) {
    throw new Error('HttpClient no está inicializado');
  }
  const url = this.urlbase + "ware/entrada/getpalets.php?id=" + id;
  return this.http.get(url);
}

createPalet(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/entrada/createpalet.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getInfoPalet(id: string | number | null | undefined):  Observable<any> {
  if (id === null || id === undefined || id === '') {
    throw new Error('getInfoPalet: id de palet no proporcionado');
  }
  const idStr = String(id);
  const url = this.urlbase+"ware/palet/getinfopalet.php?id="+encodeURIComponent(idStr);
  let dato:any=this.http.get(url);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getHistoricoMovimientosPalet(id: string | number | null | undefined): Observable<any> {
  if (id === null || id === undefined || id === '') {
    throw new Error('getHistoricoMovimientosPalet: id de palet no proporcionado');
  }
  const idStr = String(id);
  const url = this.urlbase + "ware/palet/gethistoricomovimientos.php?id=" + encodeURIComponent(idStr);
  let dato: any = this.http.get(url);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

saveAnotacionPalet(idpalet: number, anotaciones: string): Observable<any> {
  let dato:any = this.http.post(this.urlbase+"ware/palet/saveanotacion.php", {idpalet: idpalet, anotaciones: anotaciones});
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getAnotacionPalet(idpalet: number): Observable<any> {
  let dato:any = this.http.get(this.urlbase+"ware/palet/getanotacion.php?id="+idpalet);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

modifyPalet(user: any,id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/entrada/modifypalet.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deletePalet(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/entrada/deletepalet.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

  //SALIDAS

  getPaletsReasignacion(idlineas_salida: number): Observable<any> {
    const payload = { idlineas_salida };
    let dato: any = this.http.post(this.urlbase + "ware/salida/getPaletsReasignacion.php", payload);
    if ((dato.code) && (dato.code == -1)) {
      this.auth.logoutUser();
      this.router.navigate(["//login"]);
    }
    return dato;
  }

  reasignarPickingPalet(idlineas_salida: number, idpalet_nuevo: number, idsalida?: number, idpalet_origen?: number): Observable<any> {
    const payload: any = { idlineas_salida, idpalet_nuevo };
    if (idsalida) {
      payload.idsalida = idsalida;
    }
    if (idpalet_origen) {
      payload.idpalet_origen = idpalet_origen;
    }
    let dato: any = this.http.post(this.urlbase + "ware/salida/reasignarPickingPalet.php", payload);
    if ((dato.code) && (dato.code == -1)) {
      this.auth.logoutUser();
      this.router.navigate(["//login"]);
    }
    return dato;
  }

  getSalidas(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/salida/getsalidas.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
addSalida(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/salida/createsalida.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getUsuariosAsignadosSalida(idsalida:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/salida/getusuariosasignadossalida.php?idsalida="+idsalida);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

saveUsuariosAsignadosSalida(idsalida:number, usuarios:number[]): Observable<any> {
  const payload = { idsalida, usuarios };
  let dato:any=this.http.post(this.urlbase+"ware/salida/saveusuariosasignadossalida.php", payload);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getIdSalidaVenta(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/salida/getsalidaventa.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
updateTransporteSalida(idsalida: number, transporte: string): Observable<any> {
  const payload = { idsalida, transporte };
  let dato: any = this.http.post(this.urlbase + "ware/salida/updatetransporte.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
updateLoteSalida(idsalida: number, lote: string): Observable<any> {
  const payload = { idsalida, lote };
  let dato: any = this.http.post(this.urlbase + "ware/salida/updateLoteSalida.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
updateTrackerSalida(idsalida: number, tracker_id: string): Observable<any> {
  const payload = { idsalida, tracker_id };
  let dato: any = this.http.post(this.urlbase + "ware/salida/updateTrackerSalida.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
updateFechaConfirmacionRecepcionSalida(idsalida: number, fecha_confirmacion_recepcion: string): Observable<any> {
  const payload = { idsalida, fecha_confirmacion_recepcion };
  let dato: any = this.http.post(this.urlbase + "ware/salida/updateFechaConfirmacionRecepcionSalida.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
updateAceptacionEnvioNoCoincideSalida(idsalida: number, aceptacion_envio_no_coincide: boolean): Observable<any> {
  const payload = { idsalida, aceptacion_envio_no_coincide };
  let dato: any = this.http.post(this.urlbase + "ware/salida/updateAceptacionEnvioNoCoincideSalida.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
uploadConfirmacionRecepcionSalida(idsalida: number, file: File): Observable<any> {
  const body = new FormData();
  body.append('idsalida', String(idsalida));
  body.append('file', file, file.name || 'confirmacion');
  let dato: any = this.http.post(this.urlbase + "ware/salida/uploadConfirmacionRecepcionSalida.php", body);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deleteConfirmacionRecepcionSalida(idsalida: number): Observable<any> {
  const payload = { idsalida };
  let dato: any = this.http.post(this.urlbase + "ware/salida/deleteConfirmacionRecepcionSalida.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
modifySalida(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/salida/modifysalida.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
reportPickingIssue(user: any[],): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/salida/reportissue.php", user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deleteSalida(id:number): Observable<any> {
    let dato:any=this.http.post(this.urlbase+"ware/salida/deletessalida.php", { id });
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

closeLineaSalida(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/salida/closelineasalida.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

closeLineaSalidaAccion(idlineaSalida: number, idproductoPalet: number, cerrarLinea: boolean = false, cantidad: number | null = null): Observable<any> {
  let url = this.urlbase + "ware/salida/closeLineaSalidaAccion.php?idlinea_salida=" + idlineaSalida + "&idproducto_palet=" + idproductoPalet + "&cerrar_linea=" + (cerrarLinea ? "1" : "0");
  if (cantidad !== null && Number.isFinite(cantidad)) {
    url += "&cantidad=" + Math.trunc(cantidad);
  }
  let dato: any = this.http.get(url);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

closeSalidaManual(idsalida:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/salida/closeSalidaManual.php?idsalida="+idsalida);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getComerciales(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getcomerciales.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getClientes(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getclientes.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
    return dato;
}

getPedidosEdi(filtros: any = {}): Observable<any> {
  const params = new HttpParams()
    .set('id', filtros.idempresa != null ? String(filtros.idempresa) : '1')
    .set('q', filtros.q || '')
    .set('estado', filtros.estado || '')
    .set('estado', filtros.estado != null ? String(filtros.estado) : '')
    .set('fecha_desde', filtros.fecha_desde || '')
    .set('fecha_hasta', filtros.fecha_hasta || '')
    .set('limit', filtros.limit != null ? String(filtros.limit) : '500');

  const dato: any = this.http.get(this.urlbase + 'ware/financiero/getpedidosedi.php', { params });
  return dato;
}

getPedidoEdi(idpedido: number, idempresa: number = 1, idcorreo?: number): Observable<any> {
  let params = new HttpParams()
    .set('id', String(idempresa))
    .set('idpedido_edi', String(idpedido));

  if (idcorreo != null) {
    params = params.set('idcorreo', String(idcorreo));
  }

  const dato: any = this.http.get(this.urlbase + 'ware/financiero/getpedidoedi.php', { params });
  return dato;
}

getFacturasEdi(filtros: any = {}): Observable<any> {
  const params = new HttpParams()
    .set('id', filtros.idempresa != null ? String(filtros.idempresa) : '1')
    .set('q', filtros.q || '')
    .set('estado', filtros.estado || '')
    .set('fecha_desde', filtros.fecha_desde || '')
    .set('fecha_hasta', filtros.fecha_hasta || '')
    .set('limit', filtros.limit != null ? String(filtros.limit) : '500');

  const dato: any = this.http.get(this.urlbase + 'ware/financiero/getfacturasedi.php', { params });
  return dato;
}

getDevoluciones(filtros: any = {}): Observable<any> {
  const params = new HttpParams()
    .set('estado', filtros.estado != null ? String(filtros.estado) : '')
    .set('texto', filtros.texto || '')
    .set('fecha_desde', filtros.fecha_desde || '')
    .set('fecha_hasta', filtros.fecha_hasta || '');

  const dato: any = this.http.get(this.urlbase + 'ware/devoluciones/getdevoluciones.php', { params });
  return dato;
}

getDevolucion(iddevolucion: number): Observable<any> {
  const params = new HttpParams().set('id', String(iddevolucion));
  const dato: any = this.http.get(this.urlbase + 'ware/devoluciones/getdevolucion.php', { params });
  return dato;
}

createDevolucion(payload: any): Observable<any> {
  const dato: any = this.http.post(this.urlbase + 'ware/devoluciones/createdevolucion.php', payload);
  return dato;
}

updateDevolucion(payload: any): Observable<any> {
  const dato: any = this.http.post(this.urlbase + 'ware/devoluciones/updatedevolucion.php', payload);
  return dato;
}

uploadAdjuntosDevolucion(iddevolucion: number, files: File[]): Observable<any> {
  const body = new FormData();
  body.append('iddevolucion', String(iddevolucion));
  (files || []).forEach((file) => body.append('files[]', file, file.name || 'adjunto'));
  const dato: any = this.http.post(this.urlbase + 'ware/devoluciones/uploadadjunto.php', body);
  return dato;
}

cambiarEstadoDevolucion(iddevolucion: number, estado: number): Observable<any> {
  const dato: any = this.http.post(this.urlbase + 'ware/devoluciones/cambiarestado.php', { iddevolucion, estado });
  return dato;
}

getFacturaEdi(idfactura: number, idempresa: number = 1): Observable<any> {
  const params = new HttpParams()
    .set('id', String(idempresa))
    .set('idfactura', String(idfactura));

  const dato: any = this.http.get(this.urlbase + 'ware/financiero/getfacturaedi.php', { params });
  return dato;
}

syncFacturasEdiAliquo(): Observable<any> {
  const dato: any = this.http.get(this.urlbase + 'ware/financiero/sync_facturas_edi_aliquo.php');
  return dato;
}

generateFacturaEdiXml(idfactura: number, idempresa: number = 1): Observable<any> {
  const params = new HttpParams()
    .set('id', String(idempresa))
    .set('idfactura', String(idfactura));

  const dato: any = this.http.get(this.urlbase + 'ware/financiero/generatefacturaedixml.php', { params });
  return dato;
}

getFacturaEdiXml(idfactura: number, idempresa: number = 1): Observable<any> {
  const params = new HttpParams()
    .set('id', String(idempresa))
    .set('idfactura', String(idfactura));

  const dato: any = this.http.get(this.urlbase + 'ware/financiero/getfacturaedixml.php', { params });
  return dato;
}

sendFacturaEdiXml(idfactura: number, idempresa: number = 1): Observable<any> {
  const params = new HttpParams()
    .set('id', String(idempresa))
    .set('idfactura', String(idfactura));

  const dato: any = this.http.get(this.urlbase + 'ware/financiero/sendfacturaedixml.php', { params });
  return dato;
}

getEdiEntidades(filtros: any = {}): Observable<any> {
  const params = new HttpParams()
    .set('id', filtros.idempresa != null ? String(filtros.idempresa) : '1')
    .set('q', filtros.q || '')
    .set('limit', filtros.limit != null ? String(filtros.limit) : '500');

  const dato: any = this.http.get(this.urlbase + 'ware/financiero/getedientidades.php', { params });
  return dato;
}

saveEdiEntidad(payload: any): Observable<any> {
  const dato: any = this.http.post(this.urlbase + 'ware/financiero/saveedientidad.php', payload);
  return dato;
}

getDireccionesCliente(idcliente:number): Observable<any> {
    let dato:any=this.http.get(this.urlbase+"ware/maestros/getdireccionescliente.php?idcliente="+idcliente);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
    return dato;
}
getPaletsSalida(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/salida/getpaletssalida.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
createPaletSalida(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/salida/createpalet.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deletePaletSalida(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/salida/deletepaletssalida.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

createLineaSalida(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/salida/createlinea.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getLineasSalida(id:number):  Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/salida/getlineas.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

modifyLineaSalida(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/salida/modifylinea.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deleteLineaSalida(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/salida/deletelinea.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getInfoPosicionPalet(id:string):  Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/palet/getinfoposicionpalet.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
saveSalidaPaletAvanzado(user: any[]): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/salida/modifydatapalet.php", user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// Actualizar Kg reales de una línea de salida (lineas_salida.peso_real)
asignarPaletLibreSalida(payload: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/salida/asignarPaletLibre.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

anadirLineaPickingLibreCaja(payload: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/salida/addLineaPickingLibreCaja.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

eliminarLineaPickingLibreCaja(payload: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/salida/deleteLineaPickingLibreCaja.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updatePesoLineaSalida(idlineas_salida: number, pesoReal: number | null): Observable<any> {
  const payload: any = { idlineas_salida, peso_real: pesoReal };
  let dato: any = this.http.post(this.urlbase + "ware/salida/updatePesoLinea.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateCantidadLineaSalidaCerrada(payload: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/salida/updateCantidadLineaCerrada.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateEstadoSalida(payload: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/salida/updateEstadoSalida.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateEstadoLineaSalida(payload: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/salida/updateEstadoLineaSalida.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

generarFotoEstadoSalida(idsalida: number): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/salida/generarFotoEstadoSalida.php", { idsalida });
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

resetLineaPickingSalida(payload: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/salida/resetLineaPickingSalida.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateCajasRealizadasProductoPalet(payload: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/salida/updateCajasRealizadasProductoPalet.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

buscarTrazabilidadSalidas(params: any = {}): Observable<any> {
  const search = new URLSearchParams();
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      search.set(key, String(value));
    }
  });

  let dato: any = this.http.get(this.urlbase + "ware/salida/buscarTrazabilidadSalidas.php" + (search.toString() ? "?" + search.toString() : ""));
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getDetalleTrazabilidadSalida(idsalida: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/salida/getDetalleTrazabilidadSalida.php?idsalida=" + idsalida);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

buscarTrazabilidadOrigen(params: any = {}): Observable<any> {
  const search = new URLSearchParams();
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      search.set(key, String(value));
    }
  });

  let dato: any = this.http.get(this.urlbase + "ware/salida/buscarTrazabilidadOrigen.php" + (search.toString() ? "?" + search.toString() : ""));
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getExportarTrazabilidadOrigenPdfUrl(params: any = {}): string {
  const search = new URLSearchParams();
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      search.set(key, String(value));
    }
  });

  return this.urlbase + "ware/salida/exportarTrazabilidadOrigenPdf.php" + (search.toString() ? "?" + search.toString() : "");
}

iniciarPicking(id:any): Observable<any>{
  let dato:any=this.http.get(this.urlbase+"ware/salida/startpicking.php?id="+id);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
// Para venta de cajas paletizadas, para guardar los datos de esos palets.

//VENTAS
getVentas(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/venta/getventas.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getVentasFirmes(id:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/venta/getventasfirmes.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getResumenPedidosAlmacen(id:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/venta/getresumenpedidosalmacen.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
addVenta(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/venta/createventa.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


modifyVenta(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/venta/modifyventa.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deleteVenta(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/venta/deleteventa.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getLineasVenta(id:number):  Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/venta/getlineas.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getPedidosTransformacion(): Observable<any> {
  return this.http.get(this.urlbase + 'ware/transformacion/getpedidostransformacion.php');
}

getCandidatosPaletsTransformacion(params: { idpedido_transformacion: number; idlinea_pedido_transformacion?: number; idlinea_venta?: number; criterio_asignacion?: string; criterios_asignacion?: any; fecha_stock?: string; palets_preindicados?: string; q?: string; permitir_stock_general?: boolean }): Observable<any> {
  const search = new URLSearchParams();
  search.set('idpedido_transformacion', String(params.idpedido_transformacion || 0));
  if (params.idlinea_pedido_transformacion) search.set('idlinea_pedido_transformacion', String(params.idlinea_pedido_transformacion));
  if (params.idlinea_venta) search.set('idlinea_venta', String(params.idlinea_venta));
  if (params.criterio_asignacion) search.set('criterio_asignacion', params.criterio_asignacion);
  if (params.criterios_asignacion) search.set('criterios_asignacion', JSON.stringify(params.criterios_asignacion));
  if (params.fecha_stock) search.set('fecha_stock', params.fecha_stock);
  if (params.palets_preindicados) search.set('palets_preindicados', params.palets_preindicados);
  if (params.q) search.set('q', params.q);
  if (params.permitir_stock_general) search.set('permitir_stock_general', '1');
  return this.http.get(this.urlbase + 'ware/transformacion/getcandidatospaletstransformacion.php?' + search.toString());
}
getPedidoTransformacion(idpedido:number, idventa?: number): Observable<any> {
  const extra = idventa ? '&idventa=' + idventa : '';
  return this.http.get(this.urlbase + 'ware/transformacion/getpedidotransformacion.php?id=' + idpedido + extra);
}
savePedidoTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/savepedidotransformacion.php', payload);
}
deletePedidoTransformacion(idpedido:number, fechaModificacion: string = ''): Observable<any> {
  const extra = fechaModificacion ? ('&fecha_modificacion=' + encodeURIComponent(fechaModificacion)) : '';
  return this.http.get(this.urlbase + 'ware/transformacion/deletepedidotransformacion.php?id=' + idpedido + extra);
}
getLineasTransformacionConfig(): Observable<any> {
  return this.http.get(this.urlbase + 'ware/transformacion/getlineastransformacion.php');
}
saveLineaTransformacionConfig(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/savelineatransformacion.php', payload);
}
deleteLineaTransformacionConfig(idlinea:number, fechaModificacion: string = ''): Observable<any> {
  const extra = fechaModificacion ? ('&fecha_modificacion=' + encodeURIComponent(fechaModificacion)) : '';
  return this.http.get(this.urlbase + 'ware/transformacion/deletelineatransformacion.php?id=' + idlinea + extra);
}
getReglasConsumoClienteTransformacion(): Observable<any> {
  return this.http.get(this.urlbase + 'ware/transformacion/getreglasconsumocliente.php');
}
saveReglaConsumoClienteTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/savereglaconsumocliente.php', payload);
}
deleteReglaConsumoClienteTransformacion(idregla:number, fechaModificacion: string = ''): Observable<any> {
  const extra = fechaModificacion ? ('&fecha_modificacion=' + encodeURIComponent(fechaModificacion)) : '';
  return this.http.get(this.urlbase + 'ware/transformacion/deletereglaconsumocliente.php?id=' + idregla + extra);
}
getReglasInterpretacionClienteTransformacion(): Observable<any> {
  return this.http.get(this.urlbase + 'ware/transformacion/getreglasinterpretacioncliente.php');
}
saveReglaInterpretacionClienteTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/savereglainterpretacioncliente.php', payload);
}
deleteReglaInterpretacionClienteTransformacion(idregla:number, fechaModificacion: string = ''): Observable<any> {
  const extra = fechaModificacion ? ('&fecha_modificacion=' + encodeURIComponent(fechaModificacion)) : '';
  return this.http.get(this.urlbase + 'ware/transformacion/deletereglainterpretacioncliente.php?id=' + idregla + extra);
}
autoasignarLineaPedidoTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/autoasignarlineapedidotransformacion.php', payload);
}
prepararPedidoTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/prepararpedidotransformacion.php', payload);
}
getPartidasTransformacion(estado?: string): Observable<any> {
  const extra = estado ? ('?estado=' + encodeURIComponent(estado)) : '';
  return this.http.get(this.urlbase + 'ware/transformacion/getpartidastransformacion.php' + extra);
}
getColaImpresionTransformacion(estado?: string, limit?: number): Observable<any> {
  const params: string[] = [];
  if (estado) {
    params.push('estado=' + encodeURIComponent(estado));
  }
  if (limit) {
    params.push('limit=' + encodeURIComponent(String(limit)));
  }
  return this.http.get(this.urlbase + 'ware/transformacion/getcolaimpresionpartidatransformacion.php' + (params.length ? ('?' + params.join('&')) : ''));
}
auditIntegracionTransformacion(limit?: number): Observable<any> {
  const extra = limit ? ('?limit=' + encodeURIComponent(String(limit))) : '';
  return this.http.get(this.urlbase + 'ware/transformacion/auditintegraciontransformacion.php' + extra);
}
runChecksTransformacion(impresionMinutos?: number, integracionLimit?: number, retryImpresion: boolean = false): Observable<any> {
  const params: string[] = [];
  if (impresionMinutos) {
    params.push('impresion_minutos=' + encodeURIComponent(String(impresionMinutos)));
  }
  if (integracionLimit) {
    params.push('integracion_limit=' + encodeURIComponent(String(integracionLimit)));
  }
  if (retryImpresion) {
    params.push('retry_impresion=1');
  }
  return this.http.get(this.urlbase + 'ware/transformacion/runcheckstransformacion.php' + (params.length ? ('?' + params.join('&')) : ''));
}
runRetryImpresionTransformacion(impresionMinutos?: number, maxReintentos?: number, limit?: number): Observable<any> {
  const params: string[] = [];
  if (impresionMinutos) {
    params.push('impresion_minutos=' + encodeURIComponent(String(impresionMinutos)));
  }
  if (maxReintentos) {
    params.push('max_reintentos=' + encodeURIComponent(String(maxReintentos)));
  }
  if (limit) {
    params.push('limit=' + encodeURIComponent(String(limit)));
  }
  return this.http.get(this.urlbase + 'ware/transformacion/runretryimpresiontransformacion.php' + (params.length ? ('?' + params.join('&')) : ''));
}
getPartidaTransformacion(idpartida:number): Observable<any> {
  return this.http.get(this.urlbase + 'ware/transformacion/getpartidatransformacion.php?id=' + idpartida);
}
getAuditoriaTransformacion(filtros: any = {}): Observable<any> {
  let params = new HttpParams();
  Object.keys(filtros || {}).forEach((key) => {
    const value = filtros[key];
    if (value !== null && value !== undefined && value !== '' && value !== false) {
      params = params.set(key, String(value));
    }
  });
  return this.http.get(this.urlbase + 'ware/transformacion/getauditoriatransformacion.php', { params });
}
getAuditoriaPartidaTransformacion(idpartida:number): Observable<any> {
  return this.http.get(this.urlbase + 'ware/transformacion/getauditoriapartidatransformacion.php?id=' + idpartida);
}
getTrazabilidadTransformacion(consulta:string, profundidad:number = 4): Observable<any> {
  const params = new HttpParams()
    .set('q', String(consulta || ''))
    .set('profundidad', String(profundidad || 4));
  return this.http.get(this.urlbase + 'ware/transformacion/gettrazabilidadtransformacion.php', { params });
}
saveProduccionPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/saveproduccionpartidatransformacion.php', payload);
}
cambiarEstadoPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/cambiarestadopartidatransformacion.php', payload);
}
reaprovecharSobrantePartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/reaprovecharsobrantepartidatransformacion.php', payload);
}

retornarSobrantesPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/retornarsobrantespartidatransformacion.php', payload);
}
registerMermaPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/registermermapartidatransformacion.php', payload);
}
uploadAdjuntoPartidaTransformacion(formData: FormData): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/uploadadjuntopartidatransformacion.php', formData);
}
registerIncidenciaPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/registerincidenciapartidatransformacion.php', payload);
}
registerConsumiblePartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/registerconsumiblepartidatransformacion.php', payload);
}
registerLecturaPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/registerlecturapartidatransformacion.php', payload);
}
logImpresionPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/logimpresionpartidatransformacion.php', payload);
}
updateImpresionPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/updateimpresionpartidatransformacion.php', payload);
}
applyLecturaPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/aplicarlecturapartidatransformacion.php', payload);
}
updateConsumoOrigenPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/updateconsumoorigenpartidatransformacion.php', payload);
}
ocultarLecturaPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/ocultarlecturapartidatransformacion.php', payload);
}
registerConciliacionPartidaTransformacion(payload: any): Observable<any> {
  return this.http.post(this.urlbase + 'ware/transformacion/registerconciliacionpartidatransformacion.php', payload);
}
createLinea(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/venta/createlinea.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
modifyLineaVenta(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/venta/modifylinea.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deleteLinea(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/venta/deletelinea.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
closeVenta(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/venta/closeventa.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
//paletizado
createLineaVentaPaletizada(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/venta/createlineapaletizada.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deleteLineaVentaPaletizada(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/venta/deletelineapaletizada.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

modifyLineaVentaPaletizada(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/venta/modifylineapaletizada.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getStock(producto:string, calibre:string, categoria:string, fechaPrevista:string, id:number){

  let dato:any=this.http.get(this.urlbase+"ware/camara/getstock.php?id="+id+"&fecha="+fechaPrevista+"&categoria="+categoria+"&calibre="+calibre+"&producto="+producto);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getCalibresYCategorias(producto:string, fechaPrevista:string, id:number){

  let dato:any=this.http.get(this.urlbase+"ware/camara/getcalibresycategorias.php?id="+id+"&fecha="+fechaPrevista+"&producto="+producto);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
//PRE-ENTRADAS
getPreentradas(idusuario:any) {
  let dato:any=this.http.get(this.urlbase+"ware/preorder/getpreorder.php?id="+idusuario);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

addPreentrada(preentrada: any) {
  const headers = { 'Content-Type': 'application/json' }; // Asegúrate de establecer el tipo de contenido
  const dato: any = this.http.post(this.urlbase + "ware/preorder/createpreorder.php", preentrada, { headers });
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
 
}

deletePreentrada(id: number) {
  let dato:any=this.http.get(this.urlbase+"ware/preorder/deletepreorder.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

//PRE-VENTAS
getPreventas(idusuario:any) {
  let dato:any=this.http.get(this.urlbase+"ware/preventa/getpreventa.php?id="+idusuario);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

addPreventa(preventa: any) {
  const headers = { 'Content-Type': 'application/json' };
  const dato: any = this.http.post(this.urlbase + "ware/preventa/createpreventa.php", preventa, { headers });
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

modifyPreventa(preventa: any) {
  const headers = { 'Content-Type': 'application/json' };
  const dato: any = this.http.post(this.urlbase + "ware/preventa/modifypreventa.php", preventa, { headers });
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deletePreventa(id: number) {
  let dato:any=this.http.get(this.urlbase+"ware/preventa/deletepreventa.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

validaVenta(idventa: number) {
  let dato:any=this.http.get(this.urlbase+"ware/venta/validaventa.php?idventa="+idventa);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// PEDIDOS CORREO
getPedidosCorreo(id:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/correo/getpedidoscorreo.php?id="+id);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getCorreo(idcorreo:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/correo/getcorreo.php?idcorreo="+idcorreo);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getCorreosVenta(idventa:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/correo/getcorreosventa.php?idventa="+idventa);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

generarSalidasDesdePedido(idventa:number, lineas:any[]): Observable<any> {
  let dato:any=this.http.post(this.urlbase+"ware/venta/generarsalidas.php?idventa="+idventa, lineas);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

guardarPedidoAlmacen(datosPedido:any): Observable<any> {
  let dato:any=this.http.post(this.urlbase+"ware/venta/guardarpedidoalmacen.php", datosPedido);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getProductoClienteMappings(limit:number = 2000): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/maestros/productoCliente/manageProductoCliente.php?action=list&limit="+limit);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getPedidoAlmacenPorVenta(idventa:number): Observable<any> {
  const url = this.urlbase + "ware/venta/getpedidoalmacen_por_venta.php?idventa=" + idventa;
  let dato:any = this.http.get(url);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateComentariosPedidoAlmacen(idpedidoAlmacen:number, comentarios:string): Observable<any> {
  const payload = { idpedido_almacen: idpedidoAlmacen, comentarios_almacen: comentarios };
  let dato:any = this.http.post(this.urlbase + "ware/venta/updatecomentariospedidoalmacen.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateCamposPedidoAlmacenProcesado(idpedidoAlmacen:number, lineas:any[]): Observable<any> {
  const payload = { idpedido_almacen: idpedidoAlmacen, lineas };
  let dato:any = this.http.post(this.urlbase + "ware/venta/updatecampospedidoalmacenprocesado.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deletePedidoAlmacen(idpedidoAlmacen:number, idventa?: number): Observable<any> {
  const payload: any = { idpedido_almacen: idpedidoAlmacen };
  if (idventa) {
    payload.idventa = idventa;
  }
  let dato:any = this.http.post(this.urlbase + "ware/venta/deletepedidoalmacen.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

//ESTADO CAMARAS
getCamaras(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

  let dato:any=this.http.get(this.urlbase+"ware/estado/getcamaras.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getPosicionesFiltro(filters: { idcamara?: number; fila?: string; altura?: string; posicion?: string; idempresa?: number } = {}): Observable<any> {
  const params = new URLSearchParams();
  if (filters.idcamara) params.set('idcamara', String(filters.idcamara));
  if (filters.fila) params.set('fila', filters.fila);
  if (filters.altura) params.set('altura', filters.altura);
  if (filters.posicion) params.set('posicion', filters.posicion);
  params.set('idempresa', String(filters.idempresa || 1));
  const url = this.urlbase + "ware/estado/getposiciones.php?" + params.toString();
  const dato: any = this.http.get(url);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getPosiciones(id:number,piso:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

  let dato:any=this.http.get<any>(this.urlbase+"ware/estado/getmapacamara.php?idCamara="+id+"&piso="+piso);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getCamaraAlmacen(idcamara: number): Observable<any> {
  const dato: any = this.http.get(this.urlbase + "ware/estado/getcamaraalmacen.php?idcamara=" + idcamara);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

buscarPaletsCamaraStock(filters: {
  idpalet?: string;
  lote?: string;
  fechaDesde?: string;
  fechaHasta?: string;
  producto?: string;
  tipoCaja?: string;
} = {}): Observable<any> {
  const params = new URLSearchParams();
  if (filters.idpalet) params.set('idpalet', filters.idpalet);
  if (filters.lote) params.set('lote', filters.lote);
  if (filters.fechaDesde) params.set('fecha_desde', filters.fechaDesde);
  if (filters.fechaHasta) params.set('fecha_hasta', filters.fechaHasta);
  if (filters.producto) params.set('producto', filters.producto);
  if (filters.tipoCaja) params.set('tipo_caja', filters.tipoCaja);

  const dato: any = this.http.get(this.urlbase + "ware/estado/buscar_palets_camara_stock.php?" + params.toString());
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getFiltrosPaletsCamaraStock(): Observable<any> {
  const dato: any = this.http.get(this.urlbase + "ware/estado/get_filtros_palets_camara_stock.php");
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getStockPaletsListado(): Observable<any> {
  const dato: any = this.http.get(this.urlbase + "ware/estado/getstockpaletslistado.php");
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getAliquoStockStatus(): Observable<any> {
  const dato: any = this.http.get(this.urlbase + "ware/stock/get_aliquo_stock_status.php");
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

syncAliquoStock(): Observable<any> {
  const dato: any = this.http.post(this.urlbase + "ware/stock/sync_aliquo_stock.php", {});
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getResumenDiaAlmacen(id: number): Observable<any> {
  const dato: any = this.http.get(this.urlbase + "ware/estado/getresumendia.php?id=" + id);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getUltimoMovimientoPalet(idcamara?: number | null, identrada?: number | null): Observable<any> {
  const params: string[] = [];
  if (idcamara) {
    params.push(`idcamara=${encodeURIComponent(String(idcamara))}`);
  }
  if (identrada) {
    params.push(`identrada=${encodeURIComponent(String(identrada))}`);
  }
  const suffix = params.length ? `?${params.join('&')}` : '';
  const dato: any = this.http.get(this.urlbase + "ware/estado/getultimomovimientopalet.php" + suffix);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getUltimosMovimientosPalet(idcamara?: number | null, identrada?: number | null, limit: number = 10): Observable<any> {
  const params: string[] = [];
  if (idcamara) {
    params.push(`idcamara=${encodeURIComponent(String(idcamara))}`);
  }
  if (identrada) {
    params.push(`identrada=${encodeURIComponent(String(identrada))}`);
  }
  params.push(`limit=${encodeURIComponent(String(limit))}`);
  const suffix = `?${params.join('&')}`;
  const dato: any = this.http.get(this.urlbase + "ware/estado/getultimosmovimientospalet.php" + suffix);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getOcupacionCamaras(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/estado/getocupacioncamaras.php?idcamara="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getResumenEstadoCamaras(idubicacion:number): Observable<any> {
    let dato:any=this.http.get(this.urlbase+"ware/estado/getresumenestadocamaras.php?idubicacion="+idubicacion);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getInfoOcupacionCamarasTotal(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/estado/getocupaciontotalcamaras.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getListadoOcupacionTotal(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/estado/getlistadototal.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getMovimientoPaletsTotal(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/estado/entradassalidasalmacen.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getOcupacionPalets(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/camara/getocupacionpalets.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getAlertasUbicacion(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/camara/alertasubicacion.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
//Maestro de empresa

//MAESTROS

//Usuarios


getUsuarios(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getusuarios.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
addUsuario(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/maestros/createusuario.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
modifyUsuario(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/maestros/modifyusuario.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deleteUsuario(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/deleteusuario.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
      this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
    return dato;
}

changePassword(userId: number, password: string, passwordConfirm: string): Observable<any> {
  const payload = { id: userId, password, passwordConfirm };
  let dato: any = this.http.post(this.urlbase + "ware/maestros/modifyusuario_password.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

changeCurrentUserPassword(password: string, passwordConfirm: string): Observable<any> {
  const payload = { password, passwordConfirm };
  let dato: any = this.http.post(this.urlbase + "ware/maestros/currentuser_password.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getEmpresas(id:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/maestros/getempresa.php?id="+id);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

addEmpresa(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/maestros/createempresa.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


updateEmpresa(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/maestros/modifyempresa.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deleteEmpresa(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/deleteempresa.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getTransportes(id:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/maestros/gettransportes.php?id="+id);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

addTransporte(data: any): Observable<any> {
  let dato:any=this.http.post(this.urlbase+"ware/maestros/createtransporte.php", data);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateTransporte(data: any,id:number): Observable<any> {
  let dato:any=this.http.post(this.urlbase+"ware/maestros/modifytransporte.php?id="+id, data);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deleteTransporte(id:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/maestros/deletetransporte.php?id="+id);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
// Certifcaciones de empresas

getEstadoCertificacion(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getestadocertificaciones.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getCertificacion(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getcertificacion.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
addCertificacion(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/maestros/createcertificacion.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


updateCertificacion(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/maestros/modifycertificacion.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deleteCertificacion(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/deletecertificacion.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getcurrentCertificacion(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getcurrentcertificacion.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


getProveedoresCertificacion(id:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/proveedor_certificacion/getproveedores.php?id="+id);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

createProveedorCertificacion(payload: any,id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/proveedor_certificacion/createproveedor.php?id="+id, payload);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

createContratoProveedorCertificacion(payload: any,id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/proveedor_certificacion/createcontrato.php?id="+id, payload);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateContratoProveedorCertificacion(payload: any,id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/proveedor_certificacion/modifycontrato.php?id="+id, payload);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


deleteContratoProveedorCertificacion(idcontrato:number,id:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/proveedor_certificacion/deletecontrato.php?id="+id+"&idcontrato="+idcontrato);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deleteProveedorCertificacion(idproveedor:number,id:number): Observable<any> {
  let dato:any=this.http.get(this.urlbase+"ware/proveedor_certificacion/deleteproveedor.php?id="+id+"&idproveedor="+idproveedor);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getFamilias(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getfamilias.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

addFamilia(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/maestros/createfamilia.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


updateFamilia(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/maestros/modifyfamilia.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deleteFamilia(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/deletefamilia.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


getSubfamilias(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getsubfamilias.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

addSubfamilia(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/maestros/createsubfamilia.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


updateSubfamilia(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/maestros/modifysubfamilia.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deleteSubfamilia(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/deletesubfamilia.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


getGrupos(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getgrupos.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

addGrupo(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/maestros/creategrupo.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


updateGrupo(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/maestros/modifygrupo.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deleteGrupo(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/deletegrupo.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


getSubgrupos(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/getsubgrupos.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

addSubgrupo(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/maestros/createsubgrupo.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


updateSubgrupo(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/maestros/modifysubgrupo.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deleteSubgrupo(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/deletesubgrupo.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}



addProducto(user: any[],id:number): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/maestros/createproducto.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


updateProducto(user: any[],id:number): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/maestros/modifyproducto.php?id="+id, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// BANDEJAS
getBandejas(id: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/maestros/getbandejas.php?id=" + id);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

addBandeja(bandeja: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/maestros/createbandeja.php", bandeja);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateBandeja(bandeja: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/maestros/modifybandeja.php", bandeja);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deleteBandeja(id: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/maestros/deletebandeja.php?id=" + id);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deleteProducto(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/maestros/deleteproducto.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
//MERMAS
createMerma(user: any): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/mermas/createmerma.php", user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
modifyMerma(user: any): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/mermas/modifymerma.php", user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deleteMerma(id:number, usuarioAccion?: string): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));
    const payload: any = { id };
    if (usuarioAccion) {
      payload.usuario_accion = usuarioAccion;
    }
    let dato:any=this.http.post(this.urlbase+"ware/mermas/deletemerma.php", payload);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
getMermas(filters: any = {}): Observable<any> {
    const params = new URLSearchParams();
    Object.keys(filters || {}).forEach((key) => {
      const value = filters[key];
      if (value !== null && value !== undefined && String(value).trim() !== '') {
        params.set(key, String(value));
      }
    });
    const query = params.toString();
    let dato:any=this.http.get(this.urlbase+"ware/mermas/getmermas.php" + (query ? "?" + query : ""));  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
resolveMerma(payload: any): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/mermas/resolvermerma.php", payload);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
// DOCUMENTOS
getDocumentos(id:number, tipo:string = 'entrada'): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/document/getDocuments.php?id="+id+"&tipo="+tipo);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

guardaDocumento(user: any, id:number, tipo:string = 'entrada'): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/document/saveDocument.php?id="+id+"&tipo="+tipo, user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

deleteDocumento(idDocumento:number, tipo:string = 'entrada'): Observable<any>{
  let dato:any=this.http.get(this.urlbase+"ware/document/deleteDocument.php?id_documento="+idDocumento+"&tipo="+tipo);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// Mantener compatibilidad con código antiguo
guardaDocumentoEntrada(user: any,id:number): Observable<any>{
  return this.guardaDocumento(user, id, 'entrada');
}

// ESTADO APLICACION

getBadgesMenu(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));


  //return new Observable((observer) => {
    // Simulación de respuesta
  //   const operations = {
  //     entradas: Math.floor(Math.random() * 10), // Ejemplo aleatorio
  //     ventas: Math.floor(Math.random() * 5),
  //     salidas: Math.floor(Math.random() * 8),
  //     alertas: Math.floor(Math.random() * 4),

  //   };
  //   observer.next(operations);
  //   observer.complete();
  // });
  
  let dato:any=this.http.get(this.urlbase+"ware/estado/getpendingbadges.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

pollBadgesMenu(id:number): Observable<{ [key: string]: number }> {
  return interval(60000).pipe(
    switchMap(() => this.getBadgesMenu(id))
  );
}

// Alarmas
getAlertas(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

  let dato:any=this.http.get(this.urlbase+"ware/alertas/getalertas.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

ackAlerta(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

  let dato:any=this.http.get(this.urlbase+"ware/alertas/ack_alerta.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

ackAlertas(ids:number[]): Observable<any> {
  const idsParam = (ids || []).filter((id: number) => Number(id) > 0).join(',');
  let dato:any=this.http.get(this.urlbase+"ware/alertas/ack_alerta.php?ids="+idsParam);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// Recordatorios globales de la aplicación
getRecordatoriosApp(): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/alertas/getRecordatoriosApp.php");
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

  manageRecordatorio(action: 'create' | 'update' | 'delete' | 'list', data?: any): Observable<any> {
  // Endpoint de gestión de recordatorios globales de la app
  const url = this.urlbase + "ware/alertas/manageRecordatorios.php?action=" + action;
  const body = data || {};
  let dato: any = this.http.post(url, body);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
 }

ackRecordatorio(idrecordatorio: number, accion: 'aceptar' | 'saltar'): Observable<any> {
  const payload = { idrecordatorio, accion };
  let dato: any = this.http.post(this.urlbase + "ware/alertas/ack_recordatorio.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

//PALETS COMPUESTOS

getPaletsDisponibles(): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/paletscompuestos/getpaletscomp.php");  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
savePaletCompuesto(user: any[]): Observable<any> {
  let dato:any= this.http.post(this.urlbase+"ware/paletscompuestos/createpaletcomp.php", user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}


modifyPaletCompuesto(user: any[]): Observable<any>{
  let dato:any=this.http.post(this.urlbase+"ware/paletscompuestos/modifypaletcomp.php", user);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}
deletePaletCompuesto(id:number): Observable<any> {
  // return this.http
  //   .get(this.serviceUrl+"ware/entrada/getentradas.php")
  //   .pipe<Entrada[]>(map((data: any) => data.users));

    let dato:any=this.http.get(this.urlbase+"ware/paletscompuestos/deletepaletcomp.php?id="+id);  
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// TEMPERATURA Y HUMEDAD

/**
 * Obtiene las cámaras que tienen sensor de temperatura configurado
 */
getCamarasConSensor(): Observable<any> {
  let dato:any = this.http.get(this.urlbase + "ware/temperatura/getcamaras_sensor.php");
  if((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

/**
 * Obtiene la última medida de temperatura y humedad para cada cámara con sensor
 */
getUltimaMedidaCamaras(): Observable<any> {
  let dato:any = this.http.get(this.urlbase + "ware/temperatura/get_ultima_medida_camaras.php");
  if((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

/**
 * Obtiene los datos de temperatura y humedad filtrados
 * @param params Objeto con camara_id, fecha_inicio, fecha_fin, magnitud
 */
getDatosTemperaturaHumedad(params: any): Observable<any> {
  const queryString = Object.keys(params)
    .map(key => `${key}=${encodeURIComponent(params[key])}`)
    .join('&');
  
  let dato:any = this.http.get(this.urlbase + "ware/temperatura/getdatos_temperatura.php?" + queryString);
  if((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

/**
 * Exporta los datos de temperatura a PDF
 * @param params Objeto con camara_id, fecha_inicio, fecha_fin, magnitud
 */
exportarTemperaturaPDF(params: any): Observable<Blob> {
  const queryString = Object.keys(params)
    .map(key => `${key}=${encodeURIComponent(params[key])}`)
    .join('&');
  
  return this.http.get(
    this.urlbase + "ware/temperatura/exportar_pdf.php?" + queryString,
    { responseType: 'blob' }
  );
}

getTrackingEnvios(params: any): Observable<any> {
  let httpParams = new HttpParams();
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== '') {
      httpParams = httpParams.set(key, String(value));
    }
  });

  let dato: any = this.http.get(this.urlbase + "ware/tracker/getEnvios.php", { params: httpParams });
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getTrackingEnvioDetalle(idsalida: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/tracker/getEnvioDetalle.php?idsalida=" + idsalida);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateTrackingAlertConfig(idsalida: number, tempMin: number | null, tempMax: number | null): Observable<any> {
  const payload = {
    idsalida,
    temp_min: tempMin,
    temp_max: tempMax,
  };
  let dato: any = this.http.post(this.urlbase + "ware/tracker/updateAlertConfig.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

updateTrackingRegistroActivo(idsalida: number, trackerRegistroActivo: boolean): Observable<any> {
  const payload = {
    idsalida,
    tracker_registro_activo: trackerRegistroActivo,
  };
  let dato: any = this.http.post(this.urlbase + "ware/tracker/updateTrackingRegistroActivo.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

exportarTrackingEnvioPDF(idsalida: number): Observable<Blob> {
  return this.http.get(
    this.urlbase + "ware/tracker/exportarSeguimientoPDF.php?idsalida=" + idsalida,
    { responseType: 'blob' }
  );
}

ocultarTrackingMedida(measurementId: number, idusuario: number | null): Observable<any> {
  const payload = {
    measurement_id: measurementId,
    idusuario: idusuario,
  };
  let dato: any = this.http.post(this.urlbase + "ware/tracker/hideMeasurement.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

/**
 * Descarga el certificado de calibración de la sonda de temperatura
 * @param camara_id ID de la cámara
 */
descargarCertificadoSonda(camara_id: number): Observable<Blob> {
  return this.http.get(
    this.urlbase + "ware/certificaciones/descargar_certificado.php?camara_id=" + camara_id,
    { responseType: 'blob' }
  );
}

/**
 * Registra un nuevo dato de temperatura y humedad
 * @param data Objeto con camara_id, temperatura, humedad, fecha_registro (opcional)
 */
registrarTemperatura(data: any): Observable<any> {
  let dato:any = this.http.post(this.urlbase + "ware/temperatura/registrar_temperatura.php", data);
  if((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

/**
 * Obtiene la configuración de alertas de una cámara
 * @param camara_id ID de la cámara
 */
getConfigAlertasCamara(camara_id: number): Observable<any> {
  let dato:any = this.http.get(this.urlbase + "ware/temperatura/config_alertas.php?camara_id=" + camara_id);
  if((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

/**
 * Alias de getConfigAlertasCamara para compatibilidad
 */
getConfigAlertas(camara_id: number): Observable<any> {
  return this.getConfigAlertasCamara(camara_id);
}

/**
 * Actualiza la configuración de alertas de una cámara
 * @param config Objeto con la configuración de alertas
 */
actualizarConfigAlertas(config: any): Observable<any> {
  let dato:any = this.http.post(this.urlbase + "ware/temperatura/config_alertas.php", config);
  if((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// ETIQUETAS
// modo simple legacy: tipo='cliente'|'interna'
getEtiquetas(tipo: string = 'cliente'): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/etiquetas/getEtiquetas.php?tipo=" + tipo);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// modo nuevo: filtros por nivel (palet/caja/bandejas), cliente, producto e idioma
getEtiquetasFiltradas(params: { nivel?: 'palet' | 'caja' | 'bandejas'; idcliente?: number; idproducto?: number; idioma?: string } = {}): Observable<any> {
  const search = new URLSearchParams();
  if (params.nivel) search.set('nivel', params.nivel);
  if (params.idcliente) search.set('idcliente', String(params.idcliente));
  if (params.idproducto) search.set('idproducto', String(params.idproducto));
  if (params.idioma) search.set('idioma', params.idioma);
  const url = this.urlbase + "ware/etiquetas/getEtiquetas.php" + (search.toString() ? ('?' + search.toString()) : '');
  let dato: any = this.http.get(url);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

imprimirEtiqueta(payload: { idetiqueta: number; tipo: 'palet' | 'caja' | 'productos_elaborados'; num_etiquetas: number; num_impresiones?: number; printer_mode?: 'palet' | 'camara'; idcamara?: number; idpalet?: number; idlinea_salida?: number; idlineas_transformado?: number; idpedido_almacen?: number; idventa?: number; contexto_caja?: 'palet' | 'linea'; producto_linea?: string; }): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/etiquetas/imprimirEtiqueta.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

crearEtiqueta(data: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/etiquetas/manageEtiquetas.php?action=create", data);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

actualizarEtiqueta(data: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/etiquetas/manageEtiquetas.php?action=update", data);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

eliminarEtiqueta(id: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/etiquetas/manageEtiquetas.php?action=delete&id=" + id);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

cambiarEstadoEtiqueta(id: number, estado: boolean): Observable<any> {
  const body = new FormData();
  body.append('id', String(id));
  body.append('estado', String(estado));
  let dato: any = this.http.post(this.urlbase + "ware/etiquetas/manageEtiquetas.php?action=setEstado", body);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// Descarga plantilla de etiqueta genérica (tabla etiquetas)
descargarEtiqueta(id: number): Observable<Blob> {
  return this.http.get(this.urlbase + "ware/etiquetas/downloadEtiqueta.php?id=" + id, {
    responseType: 'blob'
  });
}

previewEtiqueta(data: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/etiquetas/previewEtiqueta.php", data);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["/login"]);
  }
  return dato;
}

getEtiquetaPreviewUrl(id: number, version?: string): string {
  const search = new URLSearchParams();
  if (version) {
    search.set('v', version);
  }
  const suffix = search.toString() ? ('?' + search.toString()) : '';
  return this.urlbase + "ware/etiquetas/previews/" + id + ".png" + suffix;
}

getTagsCatalogo(): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/etiquetas/getTagsCatalogo.php");
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["/login"]);
  }
  return dato;
}

// ETIQUETAS CLIENTE
getEtiquetasCliente(): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/etiquetas-cliente/getEtiquetasCliente.php");
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

crearEtiquetaCliente(formData: FormData): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/etiquetas-cliente/manageEtiquetasCliente.php?action=create", formData);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

eliminarEtiquetaCliente(id: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/etiquetas-cliente/manageEtiquetasCliente.php?action=delete&id=" + id);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

descargarEtiquetaCliente(id: number): Observable<Blob> {
  return this.http.get(this.urlbase + "ware/etiquetas-cliente/descargarEtiquetaCliente.php?id=" + id, {
    responseType: 'blob'
  });
}

// UBICACIONES
getUbicaciones(empresaId: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/maestros/getubicaciones.php?id=" + empresaId);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// IMPRESORAS
getImpresoras(empresaId: number, ubicacionId?: number): Observable<any> {
  let url = this.urlbase + "ware/impresoras/getImpresoras.php?id=" + empresaId;
  if (ubicacionId) {
    url += "&idubicacion=" + ubicacionId;
  }
  let dato: any = this.http.get(url);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

crearImpresora(data: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/impresoras/manageImpresoras.php?action=create", data);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

actualizarImpresora(data: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/impresoras/manageImpresoras.php?action=update", data);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

eliminarImpresora(id: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/impresoras/manageImpresoras.php?action=delete&id=" + id);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

toggleImpresora(id: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/impresoras/manageImpresoras.php?action=toggle&id=" + id);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getTiposImpresora(): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/impresoras/getTiposImpresora.php");
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// IMPRIMIR ALBARAN
imprimirAlbaran(idsalida: number, idcamara: number, num_impresiones?: number): Observable<any> {
  const payload: any = { idsalida, idcamara };
  if (num_impresiones !== undefined) {
    payload.num_impresiones = num_impresiones;
  }
  let dato: any = this.http.post(this.urlbase + "ware/salida/imprimirAlbaran.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

generarAlbaran(idsalida: number, retransmitirAliquo: boolean = false): Observable<any> {
  const payload: any = { idsalida, retransmitir_aliquo: retransmitirAliquo };
  let dato: any = this.http.post(this.urlbase + "ware/salida/generarAlbaran.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// IMPRIMIR CARTEL
imprimirCartel(idsalida: number, idcamara: number, texto_cartel: string, num_impresiones?: number): Observable<any> {
  const payload: any = { idsalida, idcamara, texto_cartel };
  if (num_impresiones !== undefined) {
    payload.num_impresiones = num_impresiones;
  }
  let dato: any = this.http.post(this.urlbase + "ware/salida/imprimirCartel.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

// TRASPASOS
getTraspasos(activo: number = 1, estado?: number, idpedidoTransformacion?: number): Observable<any> {
  let url = this.urlbase + "ware/traspaso/getTraspasos.php?activo=" + activo;
  if (estado !== undefined) {
    url += "&estado=" + estado;
  }
  if (idpedidoTransformacion !== undefined && Number(idpedidoTransformacion) > 0) {
    url += "&idpedido_transformacion=" + encodeURIComponent(String(idpedidoTransformacion));
  }
  let dato: any = this.http.get(url);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getLineasTraspaso(idtraspaso: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/traspaso/getLineasTraspaso.php?idtraspaso=" + idtraspaso);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

crearTraspaso(data: any): Observable<any> {
  const payload = { action: 'create', ...data };
  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

actualizarTraspaso(data: any): Observable<any> {
  const payload = { action: 'update', ...data };
  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

eliminarTraspaso(idtraspaso: number): Observable<any> {
  const payload = { action: 'delete', idtraspaso };
  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

realizarLineaTraspaso(idlineas_traspaso: number, merma: number = 0, observaciones: string = ''): Observable<any> {
  const payload = { action: 'realizarLinea', idlineas_traspaso, merma, observaciones };
  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

	marcarMermaTraspaso(idlineas_traspaso: number, merma: number, observaciones: string = ''): Observable<any> {
	  const payload = { action: 'marcarMerma', idlineas_traspaso, merma, observaciones };
	  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
	  }
	  return dato;
	}

	cerrarLineaTransformacionLibre(data: {
	  idtraspaso: number;
	  idlinea_pedido_transformacion: number;
	  palet_origen: string;
	  cajas: number;
	  unidades_sueltas: number;
	  piezas_sueltas_usadas?: number;
	  piezas_desde_cajas?: number;
	  piezas_aportadas?: number;
	  observaciones?: string;
	}): Observable<any> {
	  const payload = { action: 'cerrarLineaTransformacionLibre', ...data };
	  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
	  if ((dato.code) && (dato.code == -1)) {
	    this.auth.logoutUser();
	    this.router.navigate(["//login"]);
	  }
	  return dato;
	}

	consultarPaletTransformacionLibre(data: {
	  idtraspaso?: number;
	  idlinea_pedido_transformacion?: number;
	  palet_origen: string;
	}): Observable<any> {
	  const payload = { action: 'consultarPaletTransformacionLibre', ...data };
	  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
	  if ((dato.code) && (dato.code == -1)) {
	    this.auth.logoutUser();
	    this.router.navigate(["//login"]);
	  }
	  return dato;
	}

	addLineaTransformacionLibre(data: {
	  idtraspaso: number;
	  idlinea_pedido_transformacion: number;
	}): Observable<any> {
	  const payload = { action: 'addLineaTransformacionLibre', ...data };
	  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
	  if ((dato.code) && (dato.code == -1)) {
	    this.auth.logoutUser();
	    this.router.navigate(["//login"]);
	  }
	  return dato;
	}

	deleteLineaTransformacionLibre(data: {
	  idtraspaso: number;
	  idlinea_pedido_transformacion: number;
	  idpedido_transformacion_traspaso: number;
	}): Observable<any> {
	  const payload = { action: 'deleteLineaTransformacionLibre', ...data };
	  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
	  if ((dato.code) && (dato.code == -1)) {
	    this.auth.logoutUser();
	    this.router.navigate(["//login"]);
	  }
	  return dato;
	}
	
	agregarLineaTraspaso(data: any): Observable<any> {
  const payload = { action: 'addLinea', ...data };
  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

eliminarLineaTraspaso(idlineas_traspaso: number): Observable<any> {
  const payload = { action: 'deleteLinea', idlineas_traspaso };
  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

iniciarPickingTraspaso(idtraspaso: number): Observable<any> {
  const payload = { action: 'iniciarPicking', idtraspaso };
  let dato: any = this.http.post(this.urlbase + "ware/traspaso/manageTraspaso.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

recibirTraspasoTransformacion(idtraspaso: number): Observable<any> {
  return this.http.post(this.urlbase + 'ware/traspaso/recibirTraspasoTransformacion.php', { idtraspaso });
}

// TRANSFORMADOS
getTransformados(activo: number = 1, estado?: number): Observable<any> {
  let url = this.urlbase + "ware/transformado/getTransformados.php?activo=" + activo;
  if (estado !== undefined) {
    url += "&estado=" + estado;
  }
  let dato: any = this.http.get(url);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getTransformado(idtransformado: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/transformado/getTransformado.php?idtransformado=" + idtransformado);
  if((dato.code)&&(dato.code==-1)){
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getLineasTransformado(idtransformado: number): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/transformado/getLineasTransformado.php?idtransformado=" + idtransformado);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

realizarLineaTransformado(idlineas_transformado: number): Observable<any> {
  const payload = { action: 'realizarLinea', idlineas_transformado };
  let dato: any = this.http.post(this.urlbase + "ware/transformado/manageTransformado.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

  registrarMermaTransformado(idlineas_transformado: number, merma: number, usar_sueltas: number, usar_cajas: number, observaciones: string = ''): Observable<any> {
  const payload = { action: 'registrarMerma', idlineas_transformado, merma, usar_sueltas, usar_cajas, observaciones };
  let dato: any = this.http.post(this.urlbase + "ware/transformado/manageTransformado.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
 }
 
 configurarCabeceraSalidaTransformado(idtransformado: number, cajas_por_palet: number, num_palets_resultado: number): Observable<any> {
  const payload = { action: 'configurarCabeceraSalida', idtransformado, cajas_por_palet, num_palets_resultado };
  let dato: any = this.http.post(this.urlbase + "ware/transformado/manageTransformado.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
 }
 
 configurarLineaSalidaTransformado(idlineas_transformado: number, bandejas_por_caja: number): Observable<any> {
  const payload = { action: 'configurarLineaSalida', idlineas_transformado, bandejas_por_caja };
  let dato: any = this.http.post(this.urlbase + "ware/transformado/manageTransformado.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
 }
 
actualizarEstadoMercanciaTransformado(idtransformado: number, mercancia_lista: boolean): Observable<any> {
  const payload = { action: 'actualizarEstado', idtransformado, mercancia_lista };
  let dato: any = this.http.post(this.urlbase + "ware/transformado/manageTransformado.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

actualizarFechaEntregaTransformado(idtransformado: number, fecha_entrega: string): Observable<any> {
  const payload = { action: 'actualizarFechaEntrega', idtransformado, fecha_entrega };
  let dato: any = this.http.post(this.urlbase + "ware/transformado/manageTransformado.php", payload);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getEstadisticasTransformados(fecha_inicio?: string, fecha_fin?: string, idproducto?: number): Observable<any> {
  let url = this.urlbase + "ware/transformado/getEstadisticas.php?";
  const params = [];
  if (fecha_inicio) params.push(`fecha_inicio=${fecha_inicio}`);
  if (fecha_fin) params.push(`fecha_fin=${fecha_fin}`);
  if (idproducto) params.push(`idproducto=${idproducto}`);
  
  url += params.join('&');
  
  let dato: any = this.http.get(url);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getAlbaranEmailConfig(): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/configuracion/getAlbaranEmailConfig.php");
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getEnvironmentConfig(): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/configuracion/getEnvironmentConfig.php");
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

getUltimosEnviosAlbaran(): Observable<any> {
  let dato: any = this.http.get(this.urlbase + "ware/configuracion/getUltimosEnviosAlbaran.php");
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

saveAlbaranEmailConfig(config: any): Observable<any> {
  let dato: any = this.http.post(this.urlbase + "ware/configuracion/saveAlbaranEmailConfig.php", config);
  if ((dato.code) && (dato.code == -1)) {
    this.auth.logoutUser();
    this.router.navigate(["//login"]);
  }
  return dato;
}

}
